import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  margin: 16px 0px 24px;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 70%;
    height: 100%;

    & + div {
      margin-left: 16px;
    }

    h1 {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.gray[900]};
    font-weight: bold;
    margin-bottom: 4px;
   }
  }

  button {
    margin-left: 16px;
    width: 40%;
    margin-top: 22px;
  }
`;

export const ListFiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.gray[100]};

  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-bottom: 12px;
  }

  h1 {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.gray[900]};
    font-weight: bold;
    margin-bottom: 4px;
  }

  span {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.gray[201]};
    margin-top: 4px;
    max-width: 600px;
  }

  div.selectContainer {
    width: 410px;
  }
`;

export const DataHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0;

  h1 {
    font-size: 18px;
    font-weight: bold;
    margin-top: 4px;
  }
`;
